import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import ar from './ar.json';

const isArabic = (lng: string) => lng.startsWith('ar');

// Wrap every interpolated value with Unicode bidi isolates (FSI/PDI) so that
// Latin-script names like "Sarah" embedded inside RTL Arabic text render in
// the correct visual order without breaking surrounding punctuation. Safe for
// Arabic values too — FSI auto-detects direction.
const isolateBidi = (value: unknown) => {
  if (typeof value === 'string' && value.length > 0) {
    return `\u2068${value}\u2069`;
  }
  return value as any;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
      // i18next calls this for every interpolation; we use it to wrap names
      // and other inline values with bidi isolates so RTL/LTR text mixes
      // cleanly. (Type cast: the option is supported at runtime but missing
      // from older type declarations in this project.)
      format: isolateBidi,
    } as any,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'fnhub-lang',
      caches: ['localStorage'],
    },
  });

// Apply RTL direction when language changes
i18n.on('languageChanged', (lng) => {
  const dir = isArabic(lng) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
  document.body.dir = dir;
});

// Set initial direction
const initDir = isArabic(i18n.language) ? 'rtl' : 'ltr';
document.documentElement.dir = initDir;
document.documentElement.lang = i18n.language || 'en';
document.body.dir = initDir;

export default i18n;
